import { render, staticRenderFns } from "./NewsLine.vue?vue&type=template&id=94fe024e"
import script from "./NewsLine.vue?vue&type=script&lang=js"
export * from "./NewsLine.vue?vue&type=script&lang=js"
import style0 from "./NewsLine.vue?vue&type=style&index=0&id=94fe024e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports